import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoney24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconMoney24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11.75 3a.75.75 0 0 1 .75.75v1.155c1.208.116 2.1.56 2.713 1.02.353.265.61.533.782.739a4 4 0 0 1 .268.366l.006.01.002.004.001.002-.633.37.634-.369a.75.75 0 0 1-1.292.762l-.002-.003-.021-.032a2 2 0 0 0-.115-.15 3.2 3.2 0 0 0-.53-.499c-.486-.364-1.268-.75-2.438-.75-1.265 0-1.992.267-2.399.616-.382.329-.601.837-.601 1.634 0 .626.288 1.065.854 1.464.605.426 1.441.74 2.402 1.088l.11.04c.881.319 1.867.676 2.63 1.188.834.56 1.504 1.374 1.504 2.595 0 1.358-.576 2.415-1.453 3.117-.693.554-1.55.87-2.422.972v1.161a.75.75 0 0 1-1.5 0v-1.187a6.3 6.3 0 0 1-2.588-1.001 6.5 6.5 0 0 1-.908-.73 5 5 0 0 1-.309-.326l-.02-.024-.006-.008-.003-.003v-.001l-.001-.001.585-.469-.586.468a.75.75 0 0 1 1.17-.94l.006.008.037.043q.054.061.17.175a5 5 0 0 0 .697.56c.615.41 1.504.811 2.631.811.798 0 1.562-.24 2.11-.68.529-.423.89-1.053.89-1.945 0-.561-.268-.966-.84-1.35-.608-.408-1.442-.71-2.405-1.059l-.01-.004c-.915-.331-1.954-.708-2.755-1.272a4 4 0 0 1-.45-.36c-.61-.564-1.04-1.315-1.04-2.33 0-1.078.306-2.07 1.124-2.772.625-.537 1.47-.835 2.501-.937V3.75a.75.75 0 0 1 .75-.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMoney24);
